import React, {
	Component
} from 'react';
import Global from '../../Global';

import './ValueServices.css';
import ThreeLogo from '../../svgs/logo-three-lg.svg';



class ValueServices extends Component {

	constructor(props) {
		super(props);

		this.state = {
			data: {
				vas: null,
				items: null
			}
		}
	}

	componentDidMount() {

		var url = Global.getAPI('plans-vas');
		fetch(url)
			.then(function(response) {
				if (response.status >= 400) {
					throw new Error('Error API: phone-vas');
				}
				return response.json();
			})
			.then(data => this.setState({
				data
			}));
	}

	render() {
		return (this.state.data.vas && this.state.data.items) ?
			<div id="value-services" ref="value-services" className='value-services container clearfix'>
				{	
					<div className='headline'>
						<img src={ThreeLogo}/>
						<div className='blurb'>
							<span class="title">{this.state.data.vas.title}</span>
							<p className='title-text'>{this.state.data.vas.text}</p>
						</div>
					</div>
				}
				<div className='data-card'>
					<div className='card-container'>
						<div className="card-table">
							{	this.state.data.items.map((item, index) => {
									return [<a className='card clearfix' key={index} href={item.link}>
										<div className="card-bg"></div>
										<div className='icon'>
											<span className='img' style={{backgroundImage:'url(' + encodeURI(item.src) + ')'}}></span>
										</div>
										<div className="item-title">
											<h3>{item.title}</h3>
										</div>
										<span className='line'></span>
										<p className='description'>{item.description}</p>
									</a>, <span className="gap" key={'gap'+index}></span>]
								})
							}
						</div>
						<div className='placeholder'></div>
					</div>
					<a href={this.state.data.vas.link} className="cta">{this.state.data.vas.label}</a>
				</div>
			</div> : null;
	}
}


export default ValueServices;